module.exports = __webpack_public_path__ + "img/ico-course.3a962201.svg";